import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const postViewerHideColumnsAPI = createApi("PostViewerHideColumns","POST");

const PostViewerHideColumns = createSlice({
  name: 'PostViewerHideColumns',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postViewerHideColumnsAPI.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postViewerHideColumnsAPI.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(postViewerHideColumnsAPI.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default PostViewerHideColumns.reducer;